import apiService from "service/api";

export const getDownloadHistory = () => {
  return apiService(
    "/vaccine/vaccinations/downloads/download-history/",
    "GET",
    null,
    true
  );
};

export const downloadHistory = (v_id: string) => {
  const url = `/vaccine/vaccinations/${v_id}/download-report/`;

  return apiService(url, "GET", null, true);
};
